import React from 'react';
import type ShapeSmartRecord from '../../shapes/ShapeSmartRecord';
import type Shape from '../../objects/Shape';
import styles from './smart-records-panel.module.css';
import { RECORD_ICONS } from '../../utils/record';
import type { ModelName, WhiteboardRecordInfo } from '../../shared-types';
import classnames from 'classnames';
import { useController } from '@aha-app/mvc';
import SmartRecordsController from '../../controllers/SmartRecordsController';
import RecordHierarchy from './RecordHierarchy';
import SmartRecordTitle from './SmartRecordTitle';

interface SmartRecordProps {
  record: Shape<ShapeSmartRecord>;
  onClick?: (id: RecordId) => void;
}

const SmartRecord: React.FC<SmartRecordProps> = ({ record, onClick }) => {
  const controller = useController(SmartRecordsController);
  return (
    <div
      className={styles.record}
      onClick={() => onClick?.(record.id)}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <SmartRecordTitle record={record} />
      {controller.recordSelected(record) && <RecordHierarchy record={record} />}
    </div>
  );
};

const AhaRecord: React.FC<{ record: WhiteboardRecordInfo }> = ({ record }) => {
  const controller = useController(SmartRecordsController);
  const type = record.typename;
  let refNum = '';
  if ('referenceNum' in record) {
    refNum = record.referenceNum ?? '';
  }

  return (
    <div
      className={classnames(styles.record, styles.ahaRecord)}
      onClick={() => {
        controller.whiteboardController.openRecordInDrawer({
          id: record.id,
          typename: record.typename as ModelName,
        });
      }}
    >
      <div className={styles.recordPill}>
        <aha-card-field>
          <i
            style={{ color: 'white' }}
            className={`record-reference-pill__icon record-reference-pill__icon--${type.toLowerCase()} ${
              RECORD_ICONS[type]
            }`}
          />
        </aha-card-field>
        <span>{refNum}</span>
      </div>
      <span className={classnames(styles.ahaRecordName, styles.truncatedName)}>
        {record.name}
      </span>
    </div>
  );
};

export { SmartRecord, AhaRecord };
